import MiddleWare from "@/helpers/middlewares.js";
import router from "@/router";
const convertArrayToObject = (array, key) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};
const maintainedErrorResponse = (error) => {
  if (Array.isArray(error)) {
    return convertArrayToObject(error);
  } else {
    return error;
  }
};
const errorHandler = (error) => {
  console.log(error);
  if (error.response !== undefined || null) {
    if (error.response.status === 500) {
      MiddleWare.notification("Internal server error !!", "danger", 2000);
    } else if (error.response.status === 404) {
      MiddleWare.notification("404 : Page Not Found !!", "danger", 2000);
    } else if (error.response.status === 403) {
      MiddleWare.notification(
        "You do not have permission to perform this action !!",
        "danger",
        2000
      );
      router.push("/404");
    } else if (error.response.status === 413 || error.response.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    } else if (error.response.status === 400) {
      if (
        error.response.data.image &&
        error.response.data.image[0] == "Unsupported file extension."
      ) {
        return MiddleWare.notification(
          "Unsupported file extension !!",
          "danger",
          2000
        );
      } else if (
        error.response.data.message ==
        "Mobile number invalid or message not sending !!"
      ) {
        return MiddleWare.notification(
          "Please verify mobile number !!",
          "danger",
          2000
        );
      }
      MiddleWare.notification("Bad request !!", "danger", 2000);
    } else {
      const response = maintainedErrorResponse(error);
      Object.keys(response).map((item) => {
        MiddleWare.notification(response[item], "danger", 2000);
      });
    }
  } else {
    MiddleWare.notification("Something went Wrong !!", "danger", 2000);
  }
};
export default errorHandler;
